import { createContext } from 'react';

import { NetSuiteAddressRecord } from '@totem/components/orgManagement/orgDetails/netSuiteKeys/types';

interface Context {
  netSuiteAddresses: NetSuiteAddressRecord[];
  searchTerm: string;
  page: number;
  pageSize: number;
  onRefresh: () => void;
  setSearchTerm: (searchTerm: string) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
}

export default createContext<Context>({
  netSuiteAddresses: [],
  searchTerm: '',
  page: 1,
  pageSize: 50,
  onRefresh: () => {},
  setSearchTerm: () => {},
  setPage: () => {},
  setPageSize: () => {},
});
